import { useAuth } from "@cometchat-ai/auth/client";
import { isHelpdeskOnlyPrincipal } from "@cometchat-ai/auth/shared";
import { Navigate } from "react-router";

/**
 * Default landing for `/w/:slug` (no sub-path). Helpdesk-only principals
 * (helpdesk_admin / helpdesk_member) land on the Helpdesk Inbox — the only
 * surface their nav shows. Everyone else (workspace admins, members, staff)
 * keeps the workspace-settings landing exactly as before.
 */
export function WorkspaceIndexRedirect() {
  const auth = useAuth();
  const to = isHelpdeskOnlyPrincipal(auth.permissions) ? "helpdesk" : "workspace";
  return <Navigate to={to} replace />;
}
